export default __webpack_public_path__ + "img/social.657f2923.png";